// extracted by mini-css-extract-plugin
module.exports = {"spacing":"Spacing-module__spacing"};